import React from 'react';
import { Dialog, DialogContent, DialogActions, Button, Slide, Box } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { closePrenotaNewDialog, setPrenotaNewStep } from '../../redux/reducers/prenotazioneNew-reducer';
import { resetPostazioneSelectedAndInfoPostazione } from '../../redux/reducers/prenotazioneStepper-reducer';
import { loadprenotazioniTableState } from '../../redux/reducers/prenotazioneTable-reducer';
import { useTranslation } from 'react-i18next';
import HeaderPrenotaNew from './Header/HeaderPrenotaNew';
import ViewEdificiNew from './Views/ViewEdificiNew';
import ViewStanzeNew from './Views/ViewStanzeNew';
import ViewPlanimetriaNew from './Views/ViewPlanimetriaNew';
import './styles/DialogPrenotaNew.css';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function DialogPrenotaNew({ isMobile }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { isPrenotaNewOpen, currentStep } = useSelector(state => state.prenotazioneNew);

    const handleClose = () => {
        dispatch(closePrenotaNewDialog());
        dispatch(loadprenotazioniTableState());
    };

    const handleBack = () => {
        dispatch(setPrenotaNewStep(currentStep - 1));
        dispatch(resetPostazioneSelectedAndInfoPostazione());
    }

    return (
        <Dialog
            fullScreen={true}
            open={isPrenotaNewOpen}
            onClose={handleClose}
            TransitionComponent={Transition}
            maxWidth={false}
            PaperProps={{
                className: `dialog-prenota-new-paper ${isMobile ? "dialog-prenota-new-paper--mobile" : ""}`
            }}
        >
            <HeaderPrenotaNew handleClose={handleClose} isMobile={isMobile} />

            <DialogContent className="dialog-prenota-new-content">
                <Box className="dialog-prenota-new-step-wrapper">
                    {currentStep === 0 && <ViewEdificiNew isMobile={isMobile} />}
                    {currentStep === 1 && <ViewStanzeNew isMobile={isMobile} />}
                    {currentStep === 2 && <ViewPlanimetriaNew isMobile={isMobile} />}
                </Box>
            </DialogContent>

            <DialogActions className="dialog-prenota-new-actions">
                {currentStep > 0 && (
                    <Button onClick={handleBack} color="inherit">
                        {t("back")}
                    </Button>
                )}
                <Button onClick={handleClose} color="inherit" className="dialog-prenota-new-btn-close">
                    {t("close")}
                </Button>
            </DialogActions>

        </Dialog>
    );
}
